<script lang="ts">
    import {LabeledValue} from 'src/features/erp-sutor/shared';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {getFirstFieldByFieldTypeIdRecursive} from 'src/features/record-grid/lib/grid-fields';
    import {FOND_REPORT} from 'src/features/erp-sutor/sutor-fonds';
    import GridFieldValue from 'shared/ui-widgets/grid/GridFieldValue.svelte';
    import ReportFondDetail from '../components/ReportFondDetail.svelte';
    import ReportWorker from '../components/ReportWorker.svelte';
    import ReportWorkerPowerKeySum from '../components/ReportWorkerPowerKeySum.svelte';

    export let record: RecordRow;

    const dateField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.dateFieldId);
    const workerField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.workerFieldId);
    const placeField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.WORK.placeFieldId);
    const partnerField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.WORK.partnerFieldId);
    const reportedPersonStandardField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.reportedPersonStandardFieldId);
    const reportedPersonOvertimeField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.reportedPersonOvertimeFieldId);
    const personUnitField = getFirstFieldByFieldTypeIdRecursive(record, FOND_REPORT.personUnitFieldId);
</script>

<ReportFondDetail {record} attendanceWorkerField={workerField} on:text-note-edit>
    <svelte:fragment slot="heading">
        <ReportWorker {workerField}/>
    </svelte:fragment>

    <svelte:fragment slot="details">
        <LabeledValue label="Místo">
            <GridFieldValue field={placeField}/>
        </LabeledValue>

        <LabeledValue label="Parťák">
            <GridFieldValue field={partnerField}/>
        </LabeledValue>

        <LabeledValue label="Vykázáno">
            <GridFieldValue field={reportedPersonStandardField} unitField={personUnitField} chipSize="sm"/>
        </LabeledValue>

        <LabeledValue label="Přesčas">
            <GridFieldValue field={reportedPersonOvertimeField} unitField={personUnitField} chipSize="sm"/>
        </LabeledValue>

        <LabeledValue label="Vykázáno v PwK">
            <ReportWorkerPowerKeySum {workerField} {dateField}/>
        </LabeledValue>
    </svelte:fragment>
</ReportFondDetail>